import { useContext } from "react"
import { NavLink, Outlet } from "react-router-dom"
import { AuthContext } from "./Authentication"
import Footer from "./Footer";


export default function RootLayout() {
  const { user } = useContext(AuthContext);

  return (
    <div className="root-layout">
        <header>
            <nav>
            <h1>Fanttech Telemetria</h1>
            <NavLink to="/">Home</NavLink>
            <NavLink to="/painel">Painel de controle</NavLink>
            <NavLink to="/sobre">Sobre</NavLink>
            {user && <button>Logout</button>}
            </nav>
        </header>
        <main>
            <Outlet />
        </main>
        <footer>
          <Footer />
        </footer>
    </div>
  )
}
